module.exports = __webpack_public_path__ + "static/media/custom4.ad825b6f.png";